import React, { useEffect, useState } from 'react';
import { View, ScrollView, FlatList, ActivityIndicator } from "react-native"
import { connect, useDispatch, useSelector } from "react-redux"
import Colors from '../../constants/Colorsv2';
import { Text, TouchableOpacity } from '../../globalComponents/NativeOverrides';
import { event_getAthletesByTeamId, event_getEventByEventId } from "../../store/actionsv1/events"
import { market_getLatestTradesByEventId } from '../../store/actionsv1/markets';
import { MarketProps, TradeProps } from '../../store/types/mk_svc';
import { EventProps, LeagueProps } from '../../store/types/sr_svc';
import AthleteEventCard from './components/AthleteMarketCard';
import EventInfoCard from './components/EventInfoCard';
import EventMarketCard from './components/EventMarketCard';
import ExoticMarketCard from './components/ExoticMarketCard';
import TeamMarketCard from './components/TeamMarketCard';
import { market_getMarketsFromSupportedMarkets } from './helpers/markets';
import { Icon } from 'react-native-elements';


const AdditionalMarketsScreen = ({ route, navigation }:any) => {
    const [ loaded, setLoaded ] = useState(false);
    const [ active_tab, setActiveTab ] = useState('athlete');
    const [ market_select_visible, setMarketSelectVisible ] = useState(false);
    const [ athletes_visible, setAthletesVisible ] = useState(false);
    const [ active_market, setActiveMarket ] = useState<MarketProps|undefined>(undefined);
    const [ toggle_width, setToggleBoxWidth ] = useState(0)
    const dispatch = useDispatch();

    const market_type:string = useSelector((state:any) => state.auth.market_type, (left, right) => left == right);
    const event:EventProps|undefined = useSelector((state:any) => state.event.events[route.params.event_id], (left, right) => {
        if(left?.time_detail == right?.time_detail){ return false }
        if(left?.supported_markets != right?.supported_markets){ return false }
        return true
    })
    const markets:MarketProps[] = useSelector((state:any) => state.market.markets, (left, right) => left.length == right.length)
    const leagues:LeagueProps[] = useSelector((state:any) => state.event.leagues, (left, right) => left.length == right.length)
    const latest_trades_list: undefined | TradeProps[] = useSelector((state:any) => state.market.latest_trades[`team:${route.params.event_id}`], (left, right) => left == right);
    let latest_trades:TradeProps[] = []
    if(latest_trades_list){ latest_trades = latest_trades_list.filter(t => t.market_type == market_type) }


    let filterable_markets = market_getMarketsFromSupportedMarkets(event?.supported_markets??[], markets)    
    let unique_market_levels = [ ...new Set(filterable_markets.filter(m => !m.primary_market).map(m => m.level)) ]
    
    filterable_markets = filterable_markets.filter(m => m.level == active_tab && !m.primary_market)
    let shown_markets = filterable_markets
    if(active_market){
        shown_markets = shown_markets.filter(m => m.market_id == active_market.market_id)
    }

    useEffect(() => {
        if(!event){ getEventDataFromServer(route.params.event_id); return }
        if(loaded){ return } //Already loaded, dont try to get more data
        getAthletesFromServer(event.away_team_id)
        getAthletesFromServer(event.home_team_id)
    },[event])


    const getAthletesFromServer = async(team_id:string) => {
        await dispatch(event_getAthletesByTeamId(team_id))
        setLoaded(false)
    }

    const getEventDataFromServer = async(event_id:string) => {
        await dispatch(event_getEventByEventId(event_id))
        await dispatch(market_getLatestTradesByEventId(event_id, 'team'))
        setLoaded(false)
    }

    const renderAthletesById = (data: {item: { athlete_id:string, market:MarketProps }, index:number}) => {

        return (
            <View style={{ margin:5 }}>
                <AthleteEventCard 
                    navigation={navigation} 
                    hide_event_info athlete_id={data.item.athlete_id}
                    event_id={route.params.event_id} 
                    event_type='team' 
                    source={'market'}
                    market_override={data.item.market}
                    do_not_load_athlete
                     />
            </View>
        )
    }

    const renderTeamsById = (data: {item: { team_id:string, market:MarketProps }, index:number}) => {
        return (
            <View style={{ margin:5 }}>
                <TeamMarketCard navigation={navigation} team_id={data.item.team_id} event_id={route.params.event_id} event_type='team' market_override={data.item.market}/>
            </View>
        )
    }

    const renderExoticsById = (data: { item: {exotic_id:string, market:MarketProps}, index:number }) => {
        return (
            <View style={{ margin:5 }}>
                <ExoticMarketCard navigation={navigation} exotic_id={data.item.exotic_id} event_id={route.params.event_id} event_type={'team'} market_override={data.item.market}/>
            </View>
        )
    }

    const renderEventMarkets = (data: { item: { market:MarketProps } }) => {
        return (
            <View style={{ margin:5 }}>
                <EventMarketCard source='market' navigation={navigation} hide_market_headers hide_event_header market_override={data.item.market} event_id={route.params.event_id}/>
            </View>
        )
    }

    const renderMarketLevels = (data: { item:string, index:number }) => {
        const active = active_tab == data.item ? true : false
        return (
            <TouchableOpacity style={{ minWidth:toggle_width/unique_market_levels.length, padding:12, justifyContent:'center', alignItems:'center',
            borderRadius:5, backgroundColor:active?Colors.shades.white : 'transparent', shadowColor: active ?"rgba(0, 0, 0, 0.2)": 'transparent', 
            shadowOffset: { width: 0, height: 1 }, shadowRadius: 0, shadowOpacity: 1 }}
            onPress={() => {
                setActiveTab(data.item)
                setActiveMarket(undefined)
                }}>
                <Text size={14} weight={active_tab === data.item ? 'bold' : 'regular'} color={active_tab === data.item ? Colors.brand.midnight : Colors.brand.slate} textAlign='center'>{data.item.toUpperCase()}</Text>
            </TouchableOpacity>
        )
    }


    const renderMarketSelector = (data: { item:MarketProps, index:number }) => {
        return (
            <TouchableOpacity style={{ padding:10, borderBottomWidth:1, borderBottomColor:Colors.shades.shade600 }} onPress={() => {
                setActiveMarket(data.item)
                setMarketSelectVisible(false);
            }}>
                <Text size={12} color={Colors.brand.electric}>{data.item.stat_label}</Text>
            </TouchableOpacity>
        )
    }

    const renderMarkets = (data: { item: MarketProps, index:number }) => {
        const trades:TradeProps[] = latest_trades.filter(t => t.market_id == data.item.market_id && t.side === data.item.trade_side)
        if(trades.length === 0){ return <></> }
        return (
            <View>
                <View style={{ backgroundColor:Colors.brand.midnight }}>
                    <Text size={16} weight='semibold' color={Colors.shades.white} style={{margin:15}}>{data.item.description}</Text>
                </View>
                {data.item.level === 'athlete' ? 
                <FlatList data={trades.sort((a,b) => b.probability - a.probability).map(t => { return { athlete_id: t.side_id, market:data.item }})} renderItem={renderAthletesById} keyExtractor={(item) => item.athlete_id.toString()} />
                :data.item.level === 'team' ?
                <FlatList data={trades.sort((a,b) => b.probability - a.probability).map(t => { return { team_id: t.side_id, market:data.item }})} renderItem={renderTeamsById} keyExtractor={(item) => item.team_id.toString()} />
                :data.item.level === 'exotic' ?
                <FlatList data={trades.sort((a,b) => b.probability - a.probability).map(t => { return { exotic_id: t.side_id, market:data.item } })} renderItem={renderExoticsById} keyExtractor={(item) => item.exotic_id.toString()}/>
                :data.item.level === 'event' ?
                <FlatList data={trades.sort((a,b) => b.probability - a.probability).map(t => { return { market:data.item } })} renderItem={renderEventMarkets} keyExtractor={(item) => trades[0]?.trade_id.toString()} />
                :<></>
                }
            </View>

        )
    }
    if(!event){
        return (
            <View style={{ padding:20, justifyContent:'center', alignItems:'center' }}>
                <ActivityIndicator size='large' color={Colors.brand.midnight} />
            </View>
        )
    }

    const league = leagues.find(l => l.league_id == event.league_id)
    return (
        <View style={{ flex:1, backgroundColor:Colors.shades.white }}>
            <ScrollView style={{ flex:1 }}>
                <EventInfoCard event={event} league={league}/>
                <View nativeID='market-toggle' style={{ flex:1, padding:2, margin:5, marginTop:20, marginRight:20, marginLeft:20, flexDirection:'row', borderRadius: 6, backgroundColor: '#e9e9e9' }} onLayout={(ev) => {
                    const { width } = ev.nativeEvent.layout;
                    setToggleBoxWidth(width)
                }}>                    
                    <FlatList showsHorizontalScrollIndicator={false} horizontal data={unique_market_levels} renderItem={renderMarketLevels} keyExtractor={(item) => item}/>
                </View>
                <View nativeID='player-markets' style={{ marginTop:10 }}>
                    <FlatList data={shown_markets} renderItem={renderMarkets} keyExtractor={(item) => item.market_id.toString()}/>
                </View>
            </ScrollView>
            <View nativeID='market_selector' style={{ padding:10, paddingLeft:20, flexDirection:'row', alignItems:'center', backgroundColor:Colors.shades.shade600 }}>
                <Text style={{ flex:1 }} size={16} color={Colors.brand.midnight} weight='bold'>FILTER</Text>
                <View style={{ borderRadius:4, borderWidth:1, borderColor:Colors.brand.electric, padding:10 }}>
                    <TouchableOpacity style={{ flexDirection:'row', alignItems:'center' }} onPress={() => setMarketSelectVisible(!market_select_visible)}>
                        <Text style={{ marginRight:4 }} size={12} color={Colors.brand.electric} weight='semibold'>{active_market?active_market.stat_label:'Select Market'}</Text>
                        <Icon name={market_select_visible?'chevron-down':'chevron-up'} color={Colors.brand.electric} type='feather' size={14} />
                    </TouchableOpacity>
                    {market_select_visible ?
                    <View style={{ position:'absolute', bottom:35, right:0 }}>
                        <View style={{ backgroundColor:Colors.shades.white, minWidth:200, maxHeight:500, borderRadius:4, shadowColor: "#000", shadowOffset: { width: 0, height: 2 }, shadowOpacity: 0.25, shadowRadius: 3.84, elevation: 5 }}>
                            <FlatList
                                data={filterable_markets}
                                renderItem={renderMarketSelector}
                                keyExtractor={(item) => item.market_id.toString()}
                            />
                        </View>
                    </View>
                    :<></>}
                </View>
            </View>
        </View>
    )
}


export default AdditionalMarketsScreen